export default __webpack_public_path__ + "static/media/ai_face_detection.8fde0f85.svg";